import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaleWorking = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 241 232",
	style: { enableBackground: "new 0 0 241 232" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.malle-working-st0{fill:#EBEBEB;}\n	.malle-working-st1{fill:#FFFFFF;}\n	.malle-working-st2{fill:#DBDBDB;}\n	.malle-working-st3{fill:#263238;}\n	.malle-working-st4{fill:#455A64;}\n	.malle-working-st5{fill:#1c70e8;}\n	.malle-working-st8{fill:#C7C7C7;}\n	.malle-working-st9{fill:#8EA1B8;}\n	.malle-working-st10{fill:#0f172b;}\n	.malle-working-st11{fill:#37474F;}\n	.malle-working-st12{fill:#EBCEA6;}\n	.malle-working-st13{fill:#A6A6A6;}\n	.malle-working-st14{opacity:0.1;}\n	.malle-working-st15{fill:#FF9ABB;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M208.4,198.6h20.3v-6.5h-20.3V198.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M158.9,135h20.3v-6.5h-20.3V135z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M219.7,206.8l10.2-0.2l5.1-0.1l5,0l-0.3,0.3v-6.5l0.3,0.3l-10.2,0l-5.1,0l-5.1-0.1l0.1-0.1L219.7,206.8z  M219.7,206.8l-0.1-6.5v-0.1h0.1l5.1-0.1l5.1,0l10.2,0h0.3v0.3l0,6.5v0.3H240l-5.1,0l-5.1-0.1L219.7,206.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M90.7,49.4l10.2-0.2l5.1-0.1h5l-0.3,0.3V43l0.3,0.3l-10.2,0l-5.1-0.1l-5.1-0.1l0.1-0.1L90.7,49.4z M90.7,49.4 L90.6,43v-0.1h0.1l5.1-0.1l5.1-0.1l10.2-0.1h0.3V43v6.5v0.3h-0.3H106l-5.1-0.1L90.7,49.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M102.1,57.6l10.2-0.2l5.1-0.1h5l-0.3,0.3l0-6.5l0.3,0.3l-10.2,0l-5.1-0.1l-5.1-0.1l0.1-0.1L102.1,57.6z  M102.1,57.6l-0.1-6.5V51h0.1l5.1-0.1l5.1-0.1l10.2,0h0.3v0.3v6.5v0.3h-0.3h-5.1l-5.1-0.1L102.1,57.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M113.4,49.4h20.3V43h-20.3V49.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M1,206.8h20.3v-6.5H1V206.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M12.3,7.5h20.3V1H12.3V7.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M1,15.6l10.2-0.2l5.1-0.1l5,0L21,15.6V9.2l0.3,0.3l-10.2,0l-5.1,0L1,9.3l0.1-0.1L1,15.6z M1,15.6L0.8,9.2V9H1 L6.1,9l5.1,0l10.2,0h0.3v0.3v6.5v0.3h-0.3h-5.1l-5.1-0.1L1,15.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M208.4,7.5l10.2-0.2l5.1-0.1l5,0l-0.3,0.3V1l0.3,0.3l-10.2-0.1l-5.1,0l-5.1-0.1l0.1-0.1L208.4,7.5z  M208.4,7.5L208.2,1V0.9h0.1l5.1-0.1l5.1,0l10.2,0h0.3V1v6.5v0.3h-0.3h-5.1l-5.1-0.1L208.4,7.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M157.3,0v112.5h73.2V0H157.3z M227.9,109.7h-67.8V2.7h67.8V109.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st1",
			d: "M227.9,2.7H160v107.1h67.8V2.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M160,57.6h67.8v-2.7H160V57.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st2",
			d: "M152.4,120.2h83.2v-7.7h-83.2V120.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st2",
			d: "M160.1,2.7h67.8V72h-67.8V2.7z M225.3,5.2h-62.8v64.3h62.8V5.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st2",
			d: "M206.2,2.7h-1.4v66.8h1.4V2.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st2",
			d: "M183,2.7h-1.4v66.8h1.4V2.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M10.4,0v112.5h73.2V0H10.4z M81,109.7H13.1V2.7H81V109.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st1",
			d: "M81,2.7H13.1v107.1H81V2.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M13.1,57.6H81v-2.7H13.1V57.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st2",
			d: "M5.5,120.2h83.2v-7.7H5.5V120.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st2",
			d: "M13.1,2.7H81V72H13.1V2.7z M78.5,5.2H15.6v64.3h62.8V5.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st2",
			d: "M59.3,2.7H58v66.8h1.4V2.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st2",
			d: "M36.1,2.7h-1.4v66.8h1.4V2.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M0,231.7l30.1-0.1l30.1-0.1l60.3-0.1l60.2,0.1l30.1,0.1l30.1,0.1l-30.1,0.1l-30.1,0.1l-60.2,0.1l-60.3-0.1 l-30.1-0.1L0,231.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st4",
			d: "M240.6,147h-73.3v10.4h73.3V147z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st4",
			d: "M238.9,157.4h-69.8v3.4h69.8V157.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M238.9,157.4h-69.8v1.1h69.8V157.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st4",
			d: "M169.8,232H167l8.1-71.2h7.1L169.8,232z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M182.2,160.8l-0.8,4.8h-6.8l0.5-4.8H182.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st4",
			d: "M238.2,232h2.8l-8.1-71.2h-7.1L238.2,232z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M225.7,160.8l0.8,4.8h6.8l-0.5-4.8H225.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M222,189.1c-0.6,2.1-0.9,4.2-1.1,6.3c0.1,0.1,0,0.5,0,0.4c0,0.3-0.5,0.3-0.5-0.1c0-0.2,0-0.4,0-0.7 c-1.2-1.5-3-2.5-4.5-3.8c-1.2-1-2-2.4-2.4-3.9c-1.2-4.1-0.1-8.5-1.5-12.6c-1.2-3.5-3.5-6.6-5.3-9.8c-2-3.4-3.5-7-3.6-11 c-0.1-3,0.2-7.1,2.6-9.4c2.5-2.4,5.5-0.6,7.4,1.6c5.5,6.3,8,14.2,9,22.3c0.6,4.5,1.2,9,1,13.5C222.8,184.3,222.5,186.7,222,189.1z "
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M220.9,197c0.3-4.2,0.2-8.5-0.2-12.7c0,0,0,0,0,0c0,0,0,0,0,0c0.1-3.4,0.3-6.8,0.2-10.3 c-0.2-3.7-0.7-7.4-1.5-11c0,0-0.1,0-0.1,0c0.7,3.6,1.1,7.2,1.2,10.8c0.1,1.9,0.1,3.9,0,5.8c0,0.6-0.1,1.3-0.1,1.9 c-1.4-9.6-4.9-18.8-10.2-27c-0.1-0.1-0.3,0-0.2,0.1c3.8,6.2,6.6,13,8.3,20c-2.6-4.9-6.6-8.9-9.5-13.5c0,0-0.1,0,0,0 c2.6,5.2,7,9.3,9.8,14.4c0.5,2.1,0.9,4.2,1.2,6.3c0.4,2.9,0.6,5.8,0.6,8.8c-1.6-3-3.3-5.8-4.6-9c0-0.1-0.2,0-0.1,0.1 c1.1,3.3,2.6,6.8,4.7,9.6c0,2.1-0.1,4.2-0.2,6.2c-0.3,5.5-1.3,11-1.7,16.5c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0-0.1,0-0.1C219.8,208.4,220.5,202.8,220.9,197z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M215,154.3C215,154.3,214.9,154.3,215,154.3c1,2.8,1.5,5.7,2.3,8.5c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1C217,159.9,216.2,157,215,154.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M240.7,166c-0.7,1.6-1.4,3.2-2.3,4.8c-1.8,3.3-3.7,6.3-4.1,10.2c-0.1,1.7-0.3,3.4-0.7,5.1 c-0.5,1.4-1.2,2.8-2,4c-2,2.9-4.4,5.4-6.3,8.3c-1.9,3.1-3.3,6.5-4.2,10c0,0.2-0.4,0.1-0.3-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c-0.3-8.3,0.4-16.6,2.9-24.5c1.1-3.5,2.4-6.9,4-10.2c1.3-2.9,3.1-5.6,5.4-7.8c1.5-1.4,4.9-4,7.1-2.6 C241.2,164,241.1,165,240.7,166z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M232.4,184.8c-1.5,2.4-3.1,4.7-4.8,6.9c-0.8,1-1.6,2.1-2.4,3.1c-0.4,0.5-0.8,1-1.2,1.5 c0.2-0.9,0.4-1.7,0.7-2.6c1.1-4.2,2.1-8.4,3.7-12.4c1.6-3.9,3.5-7.6,5.7-11.2c0.1-0.1-0.1-0.2-0.2-0.1c-1.7,2.9-3.5,5.8-5,8.8 c-0.8,1.7-1.5,3.4-2.1,5.2c0.7-3.8,1.6-7.5,2.8-11.1c0,0,0-0.1-0.1,0c-1.6,3.7-2.6,7.6-2.9,11.5c-0.4,1.1-0.7,2.2-1,3.2 c-1.3,4.6-2.4,9.3-3.5,14c0-3.1,0.3-6.2,0.8-9.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.8,3.2-1.1,6.4-0.8,9.7 c-0.4,1.8-0.8,3.6-1.2,5.3c-0.8,3.8-1.8,7.7-2.3,11.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.6-2.1,0.9-4.2,1.4-6.3 c0.5-2.1,0.9-4.2,1.4-6.3c0.7-3.1,1.5-6.1,2.2-9.2c0.5-1.1,1.5-2.1,2.2-3.1c0.7-0.9,1.6-2.1,2.4-3.1 C230,189,231.3,186.9,232.4,184.8C232.5,184.8,232.4,184.7,232.4,184.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M232.8,181.2c-1.8,2.3-3.4,4.8-4.7,7.5c0,0,0,0.1,0.1,0C229.7,186.3,231.2,183.8,232.8,181.2 C232.9,181.2,232.8,181.2,232.8,181.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M197.5,173.9c1.1,1.8,2.3,4,1.8,6.3c-0.3,1.4-1.3,2.5-1.5,4c-0.4,3.2,2.7,5.2,5,6.7c5.7,3.7,13.5,7,14.5,14.6 c0,0.3,0.5,0.2,0.5-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0.7-3.8,0.7-7.8-0.1-11.6c-0.8-3.9-2.6-7.4-4.6-10.9 c-3.4-5.8-7.1-11.8-12.2-16.2c-1.4-1.2-4.4-3.5-5.5-0.7C194.3,168.7,196.2,171.6,197.5,173.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M202.7,186.2c3.8,4.1,9.8,6.3,13,10.9c-1.8-6.9-5.2-13.4-10-18.7c0,0,0-0.1,0-0.1s0-0.1,0-0.1 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c3.5,3.4,6.2,7.4,8.2,11.8c-0.9-3.1-2.1-6.1-3.5-9c-0.1-0.1,0.1-0.2,0.2-0.1 c1.8,3.1,3.1,6.5,3.8,10.1c4.3,10.3,4.7,22.4,3.8,33.3c0,0.1-0.2,0.2-0.2,0c0.2-8.6,0.1-17.3-2-25.7l-0.1-0.5 C212.5,193.2,206.5,190.9,202.7,186.2C202.7,186.3,202.6,186.3,202.7,186.2C202.7,186.2,202.7,186.2,202.7,186.2 C202.7,186.2,202.7,186.2,202.7,186.2C202.7,186.2,202.7,186.2,202.7,186.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M201.8,182.7c2,1.8,3.9,3.7,5.9,5.5c0,0,0,0.1,0,0c-2.2-1.5-4.3-3.3-6-5.4c0,0,0,0,0-0.1c0,0,0,0,0-0.1 C201.8,182.7,201.8,182.7,201.8,182.7C201.8,182.7,201.8,182.7,201.8,182.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M201.5,174.9c1.7,2.9,3.7,5.6,5.9,8.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c-2.5-2.3-4.5-5.1-6-8.1c0,0,0,0,0-0.1C201.4,174.9,201.4,174.8,201.5,174.9C201.5,174.8,201.5,174.8,201.5,174.9 C201.5,174.8,201.5,174.9,201.5,174.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st4",
			d: "M210.4,232h17.3l-2.3-23.3h-12.3L210.4,232z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M212.7,212.5h13.1l-0.4-3.8h-12.3L212.7,212.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st4",
			d: "M211,209.9h16.2v-3.7H211V209.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M22.5,73.4h-3.1v155.5h3.1V73.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M74.2,18.4L0,92.4l2.2,2.2l74.2-74L74.2,18.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M4,228.9v3.1h33.8v-3.1H4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M76.7,29.9l10.5-9.8l-9.8-8l-7.8,7.4L76.7,29.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st6",
			d: "M87.1,20.1l-10.5,9.8l-2.9-4.1l9-9.2L87.1,20.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M75.6,46.3l28.2-26.5l-13.5-7.2L69.2,32.4L75.6,46.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st7",
			d: "M185.7,130c0,0-10-4.6-10-10.8c0-6.2,13-10.2,13-15c0-4.8-5.7-7.7-5.7-7.7s9,3.1,9,9.2 c0,6.1-8.6,10.3-9.4,14.1C181.4,125.2,185.7,130,185.7,130z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st7",
			d: "M185.2,130c0,0,10-3.6,10-8.5c0-4.9-13-8-13-11.8c0-3.8,5.7-6,5.7-6s-9,2.4-9,7.2c0,4.8,9.8,8.1,10.6,12 C190.2,126.8,185.2,130,185.2,130z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M190.3,145.5h-9.5v1.5h9.5V145.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st6",
			d: "M190.3,145.5h-9.5v1h9.5V145.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M201.7,141.5c-0.7,1-1.7,1.8-2.8,2.1c-1.2,0.4-2.4,0.3-3.5-0.1c-0.5-0.2-0.9-0.4-1.3-0.7l1.2-1.8 c0.2,0.2,0.5,0.3,0.7,0.4c0.7,0.3,1.5,0.4,2.2,0.2c0.7-0.2,1.4-0.7,1.8-1.3c1.3-1.8,1.8-6,0.5-7.6c-0.1-0.1-0.5-0.3-2,0 c-0.3,0.1-0.6,0.1-1,0.2c-0.3,0.1-0.6,0.2-0.9,0.2l0-1.1l-0.1-1.1c0.1,0,0.3-0.1,0.5-0.1c0.7-0.2,1.4-0.4,2.2-0.4 c1.1-0.1,2.3,0,3,0.9C204.2,133.9,203.3,139.2,201.7,141.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st6",
			d: "M195.2,141.1c0.2,0.2,0.5,0.3,0.7,0.4l-0.6,2.1c-0.5-0.2-0.9-0.4-1.3-0.7L195.2,141.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st6",
			d: "M199,130.4l-0.6,2.3c-0.3,0.1-0.6,0.1-1,0.2c-0.3,0.1-0.6,0.2-0.9,0.2l0-1.1l-0.1-1.1c0.1,0,0.3-0.1,0.5-0.1 C197.5,130.6,198.2,130.5,199,130.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M172.9,127.6c0,0,0.1,0.7,0.2,1.8c0,0.2,0.1,0.4,0.1,0.6c0.1,0.8,0.3,1.7,0.4,2.7c0,0.1,0,0.1,0,0.2 c0.3,1.4,0.6,2.9,0.9,4.4c0,0.1,0,0.1,0.1,0.2c0.1,0.4,0.2,0.8,0.3,1.2c0.1,0.4,0.2,0.7,0.3,1.1c0.2,0.6,0.4,1.2,0.7,1.8 c2,4.1,4.7,4.5,6.5,4.5h6.2c1.7,0,4.5-0.5,6.4-4.5l0.2-0.4c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2 c0.4-1.2,0.7-2.3,1-3.5c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0.1-0.5,0.2-1,0.3-1.5c0.2-0.8,0.3-1.7,0.5-2.4c0.1-0.4,0.1-0.7,0.2-1 c0-0.1,0-0.2,0-0.3c0-0.2,0.1-0.4,0.1-0.7c0-0.2,0.1-0.4,0.1-0.6c0-0.2,0.1-0.4,0.1-0.6c0.1-1,0.2-1.7,0.2-1.7L172.9,127.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st6",
			d: "M173.7,132.8c0.3,1.4,0.6,2.9,0.9,4.4c0.2,0,0.3,0.1,0.5,0.1c0.8,0.2,1.5,0.5,2.1,0.9 c0.6,0.4,1.2,0.9,1.8,1.5c0.5,0.5,1.1,1,1.7,1.5c0.6,0.4,1.3,0.7,2.1,0.7c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.6-0.4,0.9-0.7 c0.5-0.5,1-1.1,1.4-1.8c0.4-0.6,0.9-1.3,1.4-1.9c0.3-0.3,0.6-0.6,0.9-0.8c0.2-0.1,0.4-0.2,0.5-0.3c0.2-0.1,0.4-0.1,0.6-0.1 c0.4,0,0.8,0.1,1.2,0.3c0.3,0.2,0.7,0.4,1,0.7c0.6,0.5,1.1,1.2,1.6,1.7c0.5,0.6,1.1,1.1,1.8,1.3c0.2,0,0.4,0,0.5,0 c0.4-1.2,0.7-2.3,1-3.5c-0.2-0.1-0.4-0.1-0.6-0.2c-0.7-0.2-1.4-0.6-2-1.1c-0.6-0.5-1.1-1.1-1.6-1.7c-0.5-0.6-1-1.1-1.6-1.6 c-0.6-0.5-1.3-0.8-2-0.9c-0.4,0-0.7,0-1.1,0.1c-0.3,0.1-0.7,0.3-0.9,0.6c-0.6,0.5-1.1,1-1.6,1.6c-0.5,0.6-1,1.2-1.6,1.7 c-0.3,0.3-0.6,0.5-1,0.7c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4,0.1-0.6,0c-0.4,0-0.8-0.2-1.2-0.4c-0.3-0.2-0.6-0.5-0.9-0.8 c-0.5-0.6-1-1.2-1.4-1.8c-0.4-0.6-1-1.2-1.6-1.5c-0.7-0.2-1.4,0.1-2,0.6C174.1,132.4,173.9,132.6,173.7,132.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st1",
			d: "M173.6,132.6c0,0.1,0,0.1,0,0.2c0.2-0.2,0.5-0.4,0.7-0.6c0.6-0.5,1.3-0.8,2-0.6c0.7,0.3,1.2,0.8,1.6,1.5 c0.5,0.6,0.9,1.3,1.4,1.8c0.3,0.3,0.6,0.6,0.9,0.8c0.3,0.2,0.7,0.4,1.2,0.4c0.2,0,0.4,0,0.6,0c0.2-0.1,0.4-0.1,0.6-0.2 c0.3-0.2,0.7-0.4,1-0.7c0.6-0.6,1.1-1.2,1.6-1.7c0.5-0.6,1-1.1,1.6-1.6c0.3-0.2,0.6-0.4,0.9-0.6c0.3-0.1,0.7-0.2,1.1-0.1 c0.7,0.1,1.4,0.4,2,0.9c0.6,0.5,1.1,1,1.6,1.6c0.5,0.6,1,1.2,1.6,1.7c0.6,0.5,1.3,0.9,2,1.1c0.2,0.1,0.4,0.1,0.6,0.2 c0,0,0-0.1,0-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-1.4-0.6-2.6-1.5-3.5-2.8c-0.5-0.6-1-1.2-1.6-1.7c-0.6-0.5-1.4-0.8-2.2-1 c-0.4,0-0.8,0-1.2,0.2c-0.4,0.1-0.7,0.3-1,0.6c-0.6,0.5-1.2,1.1-1.6,1.7c-0.5,0.6-1,1.2-1.5,1.7c-0.5,0.5-1.2,1-1.9,0.9 c-0.4-0.1-0.7-0.2-1-0.4c-0.3-0.2-0.6-0.4-0.8-0.7c-0.5-0.6-0.9-1.2-1.4-1.8c-0.4-0.7-1.1-1.2-1.8-1.5c-0.4-0.1-0.8-0.1-1.2,0.1 c-0.4,0.1-0.7,0.4-1,0.6C174,132.2,173.8,132.4,173.6,132.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st1",
			d: "M174.6,137.1c0,0.1,0,0.1,0.1,0.2l0.4,0.1c1.5,0.4,2.8,1.3,3.8,2.4c0.5,0.6,1.1,1.1,1.7,1.5 c0.7,0.4,1.5,0.7,2.3,0.7c0.4,0,0.8-0.1,1.2-0.3c0.4-0.2,0.7-0.4,1-0.7c0.6-0.6,1-1.2,1.5-1.8c0.4-0.6,0.9-1.3,1.4-1.8 c0.5-0.5,1.1-1.1,1.8-1.1c0.7,0,1.4,0.4,1.9,0.9c0.6,0.5,1.1,1.1,1.6,1.7c0.5,0.6,1.2,1.1,1.9,1.3c0.2,0,0.3,0,0.5,0 c0-0.1,0.1-0.2,0.1-0.2c-0.2,0-0.4,0-0.5,0c-0.7-0.3-1.3-0.7-1.8-1.3c-0.5-0.6-1-1.2-1.6-1.7c-0.3-0.3-0.6-0.5-1-0.7 c-0.4-0.2-0.8-0.3-1.2-0.3c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.2-0.5,0.3c-0.3,0.2-0.6,0.5-0.9,0.8c-0.5,0.6-1,1.2-1.4,1.9 c-0.4,0.6-0.9,1.2-1.4,1.8c-0.2,0.3-0.5,0.5-0.9,0.7c-0.3,0.2-0.7,0.2-1,0.3c-0.7,0-1.5-0.3-2.1-0.7c-0.6-0.4-1.2-0.9-1.7-1.5 c-0.5-0.6-1.1-1-1.8-1.5c-0.6-0.4-1.4-0.7-2.1-0.9C174.9,137.2,174.8,137.2,174.6,137.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st8",
			d: "M73.6,196.2l-44.1,35.5H32l51-35.5H73.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st8",
			d: "M77.8,196.2L56,231.7h2.5l26.7-35.5H77.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st8",
			d: "M88.5,196.2l21.8,35.5h-2.5l-26.7-35.5H88.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st8",
			d: "M92.3,196.2l44.1,35.5h-2.5L83,196.2H92.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st9",
			d: "M165.9,183.2v-10.4l-60.6-2.5L73.3,85H0l25.9,98.1l62,17.4h3.9L165.9,183.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st10",
			d: "M0,85h8.4l27,89.5L90.3,190l75.7-17.2v10.4l-74.1,17.4h-3.9l-62-17.4L0,85z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M210.5,231.4c-2,0-52.7-15.6-54.2-17.4c-0.2-0.2,0.6-7.7,1.9-13.6c0.1-0.3-18-23.9-18-23.9l32.7-12.7 l15.6,32.3l4,8.4c0,0,16.9,17,18.4,19.1C212.4,225.7,212.4,231.3,210.5,231.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M211.9,231.6c-2,0.1-55-16.1-56.6-18c-0.6-0.7,0.3-4,2.9-13.4l34.7,4.2c0,0,17.9,16.8,19.5,19 C213.9,225.7,213.9,231.6,211.9,231.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M211.8,229.3c-8.8-2.9-44.6-13.9-53.5-16.1c-0.1,0-0.1,0,0,0.1c8.7,3.1,44.5,13.7,53.5,16.2 C211.9,229.5,212,229.4,211.8,229.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M209.5,220.6c-1-0.3-2-0.4-3-0.4c-1,0.1-2,0.4-2.9,0.9c-1.6,0.9-2.9,2.4-3.4,4.1c0,0.1,0.1,0.1,0.1,0 c0.8-1.7,2.2-3,3.9-3.8C205.8,220.6,207.7,220.3,209.5,220.6C209.5,220.7,209.5,220.7,209.5,220.6 C209.5,220.7,209.5,220.7,209.5,220.6C209.5,220.6,209.5,220.6,209.5,220.6C209.5,220.6,209.5,220.6,209.5,220.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M196.5,208c-3.5-1.2-8-1.2-11.1,1.1c-0.1,0.1,0,0.3,0.1,0.2c3.6-0.7,7.3-1,10.9-0.9c0.1,0,0.1,0,0.2,0 c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2C196.6,208,196.5,208,196.5,208z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M198.9,209.9c-3.5-1.2-8-1.2-11.1,1.1c-0.1,0.1,0,0.3,0.1,0.2c3.6-0.7,7.3-1,10.9-0.9c0.1,0,0.1,0,0.2,0 c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2C199,209.9,198.9,209.9,198.9,209.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M201.3,211.8c-3.5-1.2-8-1.2-11.1,1.1c-0.1,0.1,0,0.3,0.1,0.2c3.6-0.7,7.3-1,10.9-0.9c0.1,0,0.1,0,0.1-0.1 c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.1C201.4,211.8,201.3,211.8,201.3,211.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M203.7,213.7c-3.5-1.2-8-1.2-11.1,1.1c-0.1,0.1,0,0.3,0.1,0.2c3.6-0.7,7.3-1,10.9-0.9c0.1,0,0.1,0,0.1-0.1 c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2C203.8,213.7,203.8,213.7,203.7,213.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M203.2,199.7c-1.3-2-4-1.3-5.6-0.1c-2.7,2.1-4.7,4.9-6,8.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c3.1-1,6.5-1.6,9.1-3.5 C202.9,203.7,204.5,201.6,203.2,199.7z M196.5,205.9c-1.5,0.5-3,1-4.5,1.5c1.1-1.6,2.3-3.2,3.6-4.6c0.6-0.7,1.3-1.4,2-2 c1.2-0.9,5.5-2.8,4.7,1.1C201.9,204.1,198.3,205.3,196.5,205.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M182.3,206.3c2.9,1.4,6.4,1.5,9.6,2c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0.1-0.1,0.1-0.2 c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-1.8-2.9-4.3-5.3-7.3-7c-1.7-0.9-4.6-1.2-5.5,1 C178.7,203.7,180.6,205.5,182.3,206.3z M180.8,203.7c-1.5-3.8,3.2-2.6,4.4-1.9c0.8,0.5,1.6,1,2.3,1.6c1.6,1.2,2.9,2.6,4.3,4 c-1.5-0.3-3.1-0.5-4.7-0.8C185.4,206.3,181.6,205.7,180.8,203.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M190.1,197.5l-36,5.3c0,0-19.7-35.6-27.6-44.5c-0.4-0.5-0.9-1-1.5-1.4c-0.8-0.4-1.7-0.6-2.6-0.7 c-10.6-1.3-46.5,2.2-71.2,0.6l11.6-15.4l5.1-6.8c27.9-3.2,62.1-14.6,77.6-6.8C162.2,136.2,190.1,197.5,190.1,197.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st11",
			d: "M185.6,191.5c-6.1,0.8-4.4,0.5-10.5,1.3c-3,0.4-18,2.5-20.8,3.3c-0.1,0,0,0.1,0,0.1c2.9,0,17.8-2.4,20.8-2.8 c6.1-1,4.3-0.8,10.4-1.8c0,0,0,0,0,0s0,0,0,0s0,0,0,0c0,0,0,0,0,0C185.7,191.5,185.7,191.5,185.6,191.5 C185.7,191.5,185.7,191.5,185.6,191.5C185.7,191.5,185.7,191.5,185.6,191.5C185.6,191.5,185.6,191.5,185.6,191.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st11",
			d: "M154.3,195.6c-4.1-6.8-22.6-40.4-26.3-41.7c-3.4-1.2-70.6,0.2-71.6,0.2c-0.1,0-0.1,0.1,0,0.1 c8-0.1,69.4-0.3,71.2,0.4c3.6,1.4,25.8,40.4,26.4,41.2C154.1,196,154.4,195.8,154.3,195.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M32.4,142.8c0,0-2.1,20.2,8.2,30.3c12.3,12,93.6,9,106.2,4.9c12.6-4.1,13-24.3-0.8-29 c-13.1-4.5-71.2-7-72.6-7.6c-1.4-0.5-5.4-7-5.4-7L32.4,142.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st11",
			d: "M49.6,142.3c0-0.1-0.2-0.1-0.2,0c0,2.6-0.9,5.2-2.6,7.2c-1.9,2.2-4.8,3.5-7.3,4.8c-0.2,0.1-0.1,0.5,0.2,0.4 c1.6-0.5,3.1-1.1,4.6-2c1.3-0.7,2.5-1.7,3.4-2.8c0.8-1.1,1.4-2.3,1.8-3.6S49.8,143.6,49.6,142.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st11",
			d: "M72.8,140.2c-0.6-0.7-1.2-1.4-1.8-2.1c-1.4-1.7-2.8-3.4-4.3-5c-0.1-0.2-0.4,0.1-0.3,0.2 c1,1.3,2.1,2.6,3.1,3.8c0.5,0.7,1.1,1.3,1.6,2c0.6,0.6,1.1,1.2,1.5,1.9c0.4,0.7-0.1,1.3-0.9,1.4c-0.7,0-1.3-0.2-1.8-0.7 c-1.2-0.9-2.1-2.2-3.1-3.3c-0.6-0.7-1.2-1.3-1.8-2s-1.3-1.4-2-2.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0.6,0.8,1.1,1.6,1.6,2.3c0.6,0.8,1.2,1.5,1.7,2.3c0.6,0.8,1.1,1.4,1.7,2.1c0.5,0.6,1.1,1.1,1.7,1.5c1.1,0.6,2.9,0.8,3.5-0.6 c0.1-0.3,0.1-0.7,0-1C73.3,140.7,73.1,140.4,72.8,140.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st11",
			d: "M145,178.2c-4.3,0.1-8.7,0.3-13,0.4c-4.3,0.1-8.6,0.1-12.9,0.1c-8.6-0.1-17.3-0.4-25.9-1 c-8.7-0.6-18.1-1.5-26.8-2.7c-4.1-0.6-8.3-1-12.4-1.9c-3.7-0.7-7.1-2.4-9.8-5c-5.6-5.5-7.8-13.4-8.7-21c-0.1-1-0.2-2-0.3-3.1 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.5,7.8,1.7,16,6.7,22.2c2.1,2.7,4.8,4.9,8,6.2c3.9,1.5,8.2,1.9,12.3,2.5 c8.7,1.2,18.1,2.1,26.9,2.8c8.7,0.7,17.6,1.1,26.4,1.2c8.8,0.1,17.6,0,26.4-0.4C142.9,178.4,143.9,178.3,145,178.2 C145,178.2,145,178.2,145,178.2C145,178.2,145,178.2,145,178.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st11",
			d: "M156.6,159.3c-0.8-3.4-2.9-6.3-5.8-8.3c-3.1-2.1-6.9-3.1-10.6-3.6c-4.2-0.6-8.4-0.9-12.6-1.3 c-8.6-0.8-17.3-1.6-25.9-2.3c-8.6-0.7-27.2-2.1-28.3-2.2c-0.1,0-0.1,0.1,0,0.2c8.3,0.9,15.9,1.7,24.3,2.5 c8.4,0.8,16.8,1.6,25.2,2.4c4.2,0.4,8.4,0.8,12.5,1.3c3.9,0.4,7.9,0.8,11.5,2.3c3.1,1.3,5.9,3.3,7.5,6.3c1.5,3,1.9,6.4,1.2,9.6 c-0.6,3-2,5.8-4,8.1c-2,2.3-4.6,3.9-7.6,4.5c-0.8,0.2-1.7,0.3-2.4,0.4c-0.1,0-0.1,0.1-0.1,0.1c6.2,0.2,12-4.4,14.3-10.1 C157.1,166,157.4,162.6,156.6,159.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st12",
			d: "M56.6,93c4.1,16.1,12.3,35.4,15.7,38.5c4.3,3.9,30.4,9,31.8,9.1c2.3,0.2,6.9-23,4.8-23 c-5.6,0.1-22.8-1.6-24.1-2.8c-1.2-1.2-10-11.7-19.1-23.6C59.6,83.1,54.1,83,56.6,93z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st12",
			d: "M102,139.7c0.4,0.2,5.8,2.7,9.1,3.6c2.5,0.7,9.6,2.3,10.6-0.3c0.7-1.8-3.4-3.3-6.3-4.4 c-1.5-0.6-3.4-2.1-3-3.1c0.7-1.7,4.6-0.1,7.2,1.3c5,2.7,11.6,7.7,14.5,5.1c1.1-1-0.2-2.6-2.2-4.3c3.2,1.9,6.5,3.4,7.8,2.4 c0.7-0.6,0.7-1.4,0.3-2.2c1,0.3,1.8,0.2,2.4-0.4c1-1.1,0.5-2.6-0.7-4.2c0.2,0,0.4-0.1,0.5-0.2c0.2-0.1,0.3-0.3,0.4-0.4 c2.1-3.3-8.9-12.4-12.6-13.2c-11-2.3-22.5-1.6-22.5-1.6C103.4,121.3,102,139.7,102,139.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M117.9,129.3c2.6,0.3,5.1,1.2,7.4,2.6c2.8,1.7,4.7,3.9,7.1,6c0.1,0.1,0,0.1-0.1,0.1c-1.2-1-5.8-4.7-7-5.6 C123,130.9,120.5,129.8,117.9,129.3L117.9,129.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M119.8,124.6c2.9,0.7,5.9,1.4,8.6,2.7c3,1.4,5.3,3.8,7.6,6.1c1.4,1.4,2.7,2.8,4,4.2c0.1,0.1,0,0.2-0.1,0.1 c-2.3-2.4-4.7-4.6-7.2-6.8c-2.3-2.1-5-3.7-7.9-4.7C123.2,125.6,121.5,125.1,119.8,124.6L119.8,124.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M122.8,120.5c2.8,0.5,5.3,0.9,7.8,2.4c3.3,1.9,6.6,5.2,7.7,6.3c1.3,1.3,2.5,2.6,3.7,3.9c0,0.1,0,0.1-0.1,0.1 c-2.7-2.9-5.6-5.7-8.7-8.2c-1.4-1.2-3.1-2.2-4.8-3C126.5,121.4,124.6,120.9,122.8,120.5C122.8,120.5,122.8,120.5,122.8,120.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M107.2,116.2l-7.9,27.1c0,0-23.2-6-27.5-10.4c-4.3-4.4-12.6-27.6-15.2-38.9c-2.5-11.3,3.2-11.1,8.7-4.1 c5.5,7,19,24,19.7,24.4C85.7,114.5,107.2,116.2,107.2,116.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M96.8,131.4c1-3.2,1.9-6.4,2.8-9.6c0.5-1.8,1-3.7,1.4-5.5c0-0.1-0.1-0.1-0.1,0c-1.1,3.2-2.2,6.3-3.1,9.6 s-1.9,6.4-2.8,9.6c-0.5,1.8-1,3.7-1.4,5.5c0,0,0.1,0.1,0.1,0C94.9,137.8,95.8,134.6,96.8,131.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st6",
			d: "M96,142.3c-6.6-1.9-20.9-6.2-24.2-9.5c-4.3-4.4-12.6-27.6-15.2-38.9c-1.2-5.4-0.5-8.2,1.1-8.8 c0.2,0.1,0.4,0.2,0.5,0.3C66.8,97,84.4,124.9,96,142.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M30,146.3c0.1,0.1,49.1-10.6,49.6-11.1c0.6-0.8-8.1-37.6-17.3-48.5c-2.3-2.7-9.7-2.5-13,0.2 C33,100.6,29.6,145.9,30,146.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st12",
			d: "M45.5,89.5c-9.8,7.5-35.5,37.8-30.1,45c5.4,7.2,42.3,4.8,53,1.7c3.2-0.9-5-21.3-8.4-22.3 c-2.8-0.8-18.8,3.5-19.1,2.6c-0.3-1,3.2-7.8,8.9-20.1C56.4,82.3,49.8,86.2,45.5,89.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st12",
			d: "M75,111.6c7.1,0.2,8.9,1.3,15-1.7c4-2,7-0.3,4.3,3.5c-4.4,6.2-13.7,7.8-17,7.5L75,111.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st12",
			d: "M55.4,115.2c0,0,8.5-3,16.1-3.6c5.3-0.4,16.8,0.1,25.8,13c2.1,3.1,3,8.9-2.3,5.2c-3.8-2.7-5.3-5.5-7.8-6.6 c0,0,0.2,7.6-3,9.6c-2.8,1.8-5.6,3.3-8.6,4.7c-0.4-0.5-0.7-1-1-1.5c0,0-3.1,1.6-8.3,0.2L55.4,115.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st12",
			d: "M76.6,112.1c2.2,1.7,6.8,5.2,9.6,9.5c3.1,4.7,7.7,14.6,4.2,16.9c-2.6,1.6-4.7-2-4.7-2s1,4.5-1.6,5.5 c-2.4,0.9-3.9-2-3.9-2s0.2,2.8-2.3,3.2c-3,0.5-2.8-5.6-6.3-7.7C70.8,134.9,76.6,112.1,76.6,112.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M80.7,124c1.8,1.9,4.9,7.3,5.1,12.4c0,0.1-0.1,0.2-0.1,0.1C84.5,132.1,82.8,127.9,80.7,124 C80.6,124,80.6,123.9,80.7,124z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M76,127.2c1.4,1.8,4.3,7.5,4.3,12.6c0,0.1-0.1,0.2-0.1,0.1C79.3,135.5,77.8,131.3,76,127.2 C75.9,127.2,76,127.2,76,127.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M87.2,123.1c2.2,1,3.5,2.4,5.1,4c0.8,0.8,1.7,1.6,2.6,2.3c0.8,0.7,2.1,1.6,3.2,1c0.6-0.3,0.7-1.2,0.7-1.8 c-0.1-1-0.4-1.9-0.8-2.8c0,0,0-0.1,0.1,0c0.4,0.8,0.7,1.6,1,2.5c0.2,0.6,0.1,1.2-0.1,1.8c-0.5,1.2-2,1.1-3,0.6 c-0.6-0.3-1.1-0.7-1.6-1.2c-0.5-0.4-1-0.8-1.4-1.3c-1-0.9-1.9-1.9-2.8-2.8C89.1,124.7,88.2,123.9,87.2,123.1 C87.1,123.2,87.1,123.1,87.2,123.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M90.6,131.9c-1-3-2.1-5.9-3.5-8.7c0,0,0-0.1,0.1,0c1.5,2,3.6,6.9,4,8.4s0.9,3.5,0.6,5c-0.4,2.4-2,2.6-2.6,2.6 c-0.7,0-1.4-0.2-2-0.7c-0.6-0.6-1.2-1.2-1.5-2c0,0,0-0.1,0.1,0c0.7,1.1,1.9,2.2,3.2,2.3c0.3,0,0.6,0,0.9-0.1 c0.3-0.1,0.5-0.2,0.7-0.4c0.4-0.5,0.7-1.2,0.7-1.8C91.3,134.8,91.1,133.3,90.6,131.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M55.4,114.2l7.4,25.7c0,0-46.1,2.6-48.7-5.7c-2.6-8.4,19.7-35.8,29-43.3c10.7-8.7,11.3-5.1,7.8,3.7 c-3.7,9.1-9.9,22.2-9.9,22.2L55.4,114.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M26.4,120.9c2.3-1.1,4.7-2,7.1-2.7c2.4-0.7,4.9-1.3,7.4-1.6c1.4-0.2,2.8-0.4,4.3-0.5c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c-2.5,0.4-5,0.9-7.4,1.6c-2.4,0.6-4.8,1.3-7.3,2C29.1,120.1,27.8,120.5,26.4,120.9 C26.4,121,26.3,120.9,26.4,120.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M55.3,114.1c-0.2,0-13.1,2-13.5,2.1c0.1-0.2,3.3-6.3,3.8-7.2c0.1-0.1,0.1-0.2,0.1-0.3 c0.3-0.4,0.6-0.8,0.9-1.2l1.1-1.5c0,0,0,0,0,0l-1.1,1.5c-0.2,0.2-0.3,0.5-0.5,0.7c0.3-0.6,0.6-1.3,1-1.9c0.5-1,1-2,1.5-3.1 c0,0,0-0.1-0.1,0c-1,1.8-2,3.5-2.9,5.3c-1,1.8-4.6,8.3-4.6,8.3s14.2-2.5,14.4-2.6c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1 C55.4,114.2,55.4,114.2,55.3,114.1C55.3,114.1,55.3,114.1,55.3,114.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M53.5,129.8c-0.8-2.9-1.6-5.8-2.5-8.6c-0.5-1.6-1-3.2-1.6-4.8c0-0.1-0.1,0-0.1,0c0.7,2.9,1.4,5.9,2.2,8.7 c0.8,2.9,1.6,5.8,2.5,8.6c0.5,1.6,1,3.2,1.6,4.8c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 C55.1,135.6,54.3,132.7,53.5,129.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M63.3,140.4c-0.3-0.8-0.7-2-1.1-2.8c-0.1-0.2-0.2-0.2-0.2,0c0.2,0.7,0.4,1.5,0.6,2.3c-0.6,0-1.3,0-1.9,0.1 l-2.2,0.1c-1.5,0.1-2.9,0.1-4.4,0.1c-3,0.1-5.9,0.1-8.9,0c-5.9-0.1-11.9-0.5-17.7-1.2c-1.6-0.2-3.3-0.5-4.9-0.8 c-1.6-0.3-3.2-0.6-4.8-1c0,0-0.1,0.1,0,0.1c1.3,0.5,2.7,0.9,4.1,1.2c1.5,0.3,2.9,0.6,4.4,0.8c3,0.5,5.9,0.8,8.9,1 c5.9,0.4,11.9,0.6,17.8,0.5c1.7,0,3.3,0,5-0.1c0.8,0,1.7-0.1,2.5-0.1C61.4,140.6,63.4,140.6,63.3,140.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st4",
			d: "M125.5,143.8h-59v2.4h59V143.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st13",
			d: "M99.2,143.8H66.5v2.4h32.7V143.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st13",
			d: "M98.2,146.2h51.7l7.3-35.1h-51.7L98.2,146.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st8",
			d: "M100.5,146.2h51.7l7.3-35.1h-51.7L100.5,146.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st0",
			d: "M126.6,129.4c-0.1,0.4,0,0.9,0.1,1.3c0.1,0.4,0.3,0.8,0.6,1.1c0.3,0.3,0.7,0.6,1.1,0.8 c0.4,0.2,0.8,0.3,1.3,0.3c0.9,0,1.9-0.4,2.6-1s1.1-1.5,1.3-2.4c0.1-0.4,0-0.9-0.1-1.3c-0.1-0.4-0.3-0.8-0.6-1.1 c-0.3-0.3-0.7-0.6-1.1-0.8c-0.4-0.2-0.8-0.3-1.3-0.3c-0.9,0-1.9,0.4-2.6,1C127.1,127.6,126.7,128.5,126.6,129.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M58.6,98.4c0,0-8.6-8.6-14.3-8.4l-4.8,4.2c0,0-1.6,0.5-2.1-0.5c-1.2-2.5-1.4-8.4,3.8-12.2 C45.9,78,53.6,78.3,60,80c6.1,1.7,11.4,5.8,9.5,9.8C67.6,93.8,58.6,98.4,58.6,98.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st6",
			d: "M59.2,96.5c0,0,7.1-5,7.8-7.9c0.8-3-5.2-5.9-9.1-7c-6-1.8-10-1.4-13.4,1.7C41.2,86.4,59.2,96.5,59.2,96.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M59.2,96.5c0,0-6.9-11.8-15.6-13.1l0.7,6.5c0,0,5.2,0.1,14.3,8.4L59.2,96.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M41.9,90.1c1.6-0.1,3.2,0.1,4.7,0.7c1.5,0.5,2.9,1.2,4.2,2c1.4,0.8,2.6,1.7,3.9,2.7l1.8,1.5l1.7,1.6l0.2,0.2 l0.2-0.1c1.6-0.8,3.2-1.8,4.7-2.8c0.8-0.5,1.5-1.1,2.2-1.7c0.7-0.6,1.3-1.2,1.9-1.9c-1.3,1.2-2.8,2.3-4.4,3.2 c-0.8,0.5-1.6,0.9-2.4,1.3c-0.8,0.4-1.6,0.8-2.4,1.2l0.4,0.1L57,96.5c-0.6-0.5-1.2-1.1-1.8-1.6c-0.6-0.5-1.3-1-1.9-1.4 c-0.7-0.5-1.3-0.9-2.1-1.3c-1.4-0.8-2.9-1.4-4.5-1.9c-0.4-0.1-0.8-0.2-1.2-0.3c-0.4-0.1-0.8-0.1-1.2-0.1 C43.5,89.9,42.7,89.9,41.9,90.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M39.5,94.2c0.9-0.6,1.7-1.2,2.5-1.9c0.8-0.7,1.6-1.4,2.3-2.2c-0.9,0.6-1.7,1.2-2.5,1.9 C40.9,92.7,40.2,93.4,39.5,94.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M55.7,94.4c-0.5,2.7-0.8,5.5-0.8,8.2c0,1.9,0.7,8.8,2.8,8.6c2.1-0.2-1.3-4.7-2-8.4c-0.6-3.6,0.4-6.3,0.5-8.5 L55.7,94.4z"
		}),
		/* @__PURE__ */ _jsx("g", {
			className: "malle-working-st14",
			children: /* @__PURE__ */ _jsx("path", {
				className: "malle-working-st6",
				d: "M55.7,94.4c-0.5,2.7-0.8,5.5-0.8,8.2c0,1.9,0.7,8.8,2.8,8.6c2.1-0.2-1.3-4.7-2-8.4c-0.6-3.6,0.4-6.3,0.5-8.5 L55.7,94.4z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st5",
			d: "M63.3,94.8c0.7,2.6,1.2,5.3,1.6,8c0.2,1.7,0.3,8-1.7,8c-2,0,0.7-4.4,0.9-7.7c0.2-3.3-1-6.3-1.3-8.3L63.3,94.8 z"
		}),
		/* @__PURE__ */ _jsx("g", {
			className: "malle-working-st14",
			children: /* @__PURE__ */ _jsx("path", {
				className: "malle-working-st6",
				d: "M63.3,94.8c0.7,2.6,1.2,5.3,1.6,8c0.2,1.7,0.3,8-1.7,8c-2,0,0.7-4.4,0.9-7.7c0.2-3.3-1-6.3-1.3-8.3 L63.3,94.8z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st12",
			d: "M59.9,95.2c-2.2-0.1-6.4-4.8-7.8-8.5C52,86.4,52.7,84,53.4,81c0.4-1.8,0.9-3.9,1.1-5.8L66,79.7 c-1,2.3-1.7,4.7-2.1,7.1c0,0.3,0,0.5,0,0.8c0,0,0,0.1,0,0.1C63.9,89.3,63.4,95.4,59.9,95.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M63.8,87.7c0,0,0,0.1,0,0.1c-0.4,0-0.8,0-1.2-0.1c-6.7-1.1-7.3-9.5-7.3-12.1L66,79.7c-1,2.3-1.7,4.7-2.1,7.1 C63.8,87.1,63.8,87.4,63.8,87.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st12",
			d: "M56.8,60.4c-2.4,3.7-3.6,16.1-1.4,19.6c3.1,5,9.9,7.3,14.6,3.2c4.5-4,5.8-20.2,3.2-23.5 C69.5,54.8,60.4,54.9,56.8,60.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M64.6,69.5c0.4-0.1,0.7-0.1,1.1-0.2c0.4,0,0.8-0.2,1.1-0.4c0.1-0.1,0.1-0.2,0.1-0.3s0-0.2-0.1-0.3 c-0.2-0.2-0.4-0.3-0.7-0.4c-0.2-0.1-0.5,0-0.7,0c-0.5,0.1-1,0.3-1.3,0.7c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3 c0.1,0.1,0.1,0.2,0.3,0.2C64.4,69.5,64.5,69.5,64.6,69.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M73,70.6c-0.4-0.1-0.7-0.3-1-0.4c-0.4-0.1-0.7-0.3-1-0.6c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.1,0.1-0.2,0.2-0.3 c0.2-0.1,0.5-0.2,0.7-0.2c0.3,0,0.5,0,0.7,0.2c0.5,0.2,0.9,0.5,1.2,1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1-0.1,0.2-0.1,0.3 c-0.1,0.1-0.2,0.2-0.3,0.2C73.3,70.7,73.2,70.7,73,70.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M64,79.3c0.2,0.2,0.3,0.5,0.6,0.6c0.3,0,0.6,0,0.9-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c-0.1,0.1-0.3,0.3-0.5,0.3c-0.2,0.1-0.4,0.1-0.6,0c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.3-0.2-0.5 C63.9,79.2,63.9,79.2,64,79.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M65.2,76.9c0.2,0.4,0.4,0.7,0.7,0.9c0.3,0.3,0.6,0.5,1,0.6c0.3,0.1,0.7,0.2,1,0.2c0.1,0,0.1,0,0.2,0h0.2 c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1v-0.1c0.1-0.6,0.2-1.6,0.2-1.6c0.2,0.1,1.3,0.8,1.4,0.5 c0.2-2.8,0.4-5.9,0-8.7c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.3,2.7-0.1,5.4-0.3,8.1c-0.4-0.3-0.8-0.4-1.3-0.6 c-0.1,0-0.1,1.9-0.2,2.2C67,78.1,66.2,77.6,65.2,76.9C65.2,76.8,65.1,76.8,65.2,76.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M67.6,78.2c-0.4,0.4-0.9,0.7-1.5,0.9c-0.3,0.1-0.6,0.1-0.9-0.1c-0.6-0.3-0.6-0.9-0.4-1.4 c0.1-0.3,0.2-0.5,0.4-0.8C65.8,77.5,66.7,78,67.6,78.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st15",
			d: "M66.1,79.1c-0.3,0.1-0.6,0.1-0.9-0.1c-0.6-0.3-0.6-0.9-0.4-1.4c0.4,0.1,0.7,0.2,0.9,0.5 C65.9,78.4,66.1,78.7,66.1,79.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M66.3,71.8C66.3,71.7,66.2,71.8,66.3,71.8c-0.2,0.9-0.4,1.8-1.2,2v0C65.9,73.8,66.3,72.6,66.3,71.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M65.7,70.8c-1.3-0.3-1.8,2.3-0.6,2.6C66.2,73.7,66.7,71.1,65.7,70.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M71.1,72.4C71.1,72.4,71.1,72.5,71.1,72.4c-0.1,0.9-0.2,1.9,0.5,2.3c0,0,0,0.1,0,0 C70.6,74.4,70.8,73.1,71.1,72.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M72,71.7c1.3,0.2,0.9,2.8-0.3,2.7C70.4,74.2,70.9,71.6,72,71.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st4",
			d: "M58,68.4c1.7-2.1,1.8-6.7,3.4-7.4c3.5-1.4,7.2,5.1,10.9,6.4c3.6,1.3,5.6-0.5,6-3.7c0.4-3.1-1.4-6-5.2-8 c-3.9-2.1-8.3-1.8-10.9-1.3c0,0,1.4-1.1,1.3-1.7c-0.2-0.6-2.4,0.2-3.2,0.6c-0.6,0.4-1.1,0.9-1.5,1.4c-0.5-0.3-1-0.6-1.6-0.8 c-0.8-0.2-1.7-0.2-2.5,0.2c-0.1,0.2,1.1,0.8,2,1.2c0,0-2.5,1.6-3.2,3.6c-0.7,1.9-1,12.2-0.3,12.6C54.2,72.1,57.3,69.3,58,68.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st4",
			d: "M57.3,55.4C57.3,55.4,57.4,55.4,57.3,55.4c-1.1,0.5-2.2,1.2-2.9,2.1c-0.8,1.2-1.4,2.5-1.5,4 c-0.4,2.7,0.1,5.5,0.3,8.2c0,0.1-0.1,0.1-0.1,0c-0.4-2.9-0.8-6-0.3-8.9C53.2,58.3,54.7,55.9,57.3,55.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st4",
			d: "M61.6,60.1c1.1,0.3,2.2,0.7,3.2,1.4c0.9,0.7,1.6,1.5,2.3,2.4c1.6,1.8,3.6,3.5,6,4.2c0,0,0,0.1,0,0 c-2.2-0.6-4.2-1.8-5.7-3.6c-0.7-0.9-1.5-1.8-2.3-2.6c-1.1-0.8-2.2-1.3-3.5-1.7c0,0,0,0,0,0C61.6,60.2,61.6,60.2,61.6,60.1 C61.6,60.2,61.6,60.1,61.6,60.1C61.6,60.1,61.6,60.1,61.6,60.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st4",
			d: "M64.9,54.3c1.7-0.2,3.4-0.1,5.1,0.1c1.6,0.2,3.2,0.7,4.7,1.5c2.5,1.4,4.3,4,4,6.9c-0.2,1.5-0.9,2.9-2,3.9 c0,0,0,0-0.1,0c0,0,0,0,0,0s0,0,0-0.1c0,0,0,0,0-0.1c1-1,1.6-2.2,1.8-3.6c0.2-1.4,0-2.7-0.7-3.9c-1.5-2.7-4.5-3.9-7.4-4.5 C68.6,54.4,66.8,54.3,64.9,54.3C64.9,54.4,64.9,54.3,64.9,54.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st11",
			d: "M63.3,75.9c-0.7-0.2-1.3-0.6-1.8-1.1c-0.5-0.5-0.8-1.2-1-1.9c-0.1-0.7-0.1-1.4,0.2-2.1 c0.3-0.7,0.7-1.3,1.3-1.7c0.6-0.4,1.3-0.7,2-0.8c0.7-0.1,1.4,0.1,2.1,0.4c0.6,0.3,1.2,0.8,1.6,1.5c0.4,0.6,0.6,1.3,0.5,2.1 c0,1-0.5,2-1.2,2.7c-0.7,0.7-1.7,1.1-2.8,1.1C63.9,76,63.6,76,63.3,75.9z M65.2,68.9c-0.3-0.1-0.5-0.1-0.8-0.1 c-0.9,0-1.7,0.3-2.3,0.9c-0.6,0.6-1,1.4-1.1,2.2s0.2,1.7,0.7,2.4c0.5,0.7,1.3,1.1,2.1,1.2c0.8,0.1,1.7-0.1,2.4-0.6 c0.7-0.5,1.2-1.2,1.4-2.1c0.2-0.8,0-1.7-0.4-2.4C66.8,69.7,66.1,69.1,65.2,68.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st11",
			d: "M72.1,77.2c-1.4-0.4-2.3-2.2-2-4.2c0.1-1,0.6-1.8,1.2-2.5c0.3-0.3,0.6-0.6,1-0.7c0.4-0.1,0.8-0.2,1.2-0.1 c0.4,0.1,0.8,0.2,1.1,0.5c0.3,0.3,0.6,0.6,0.7,1c0.4,0.9,0.6,1.8,0.4,2.8c-0.3,2.1-1.9,3.6-3.5,3.4L72.1,77.2z M73.6,70.2l-0.2,0 c-0.3,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.3-0.8,0.6c-0.6,0.6-1,1.4-1.1,2.3c-0.3,1.8,0.5,3.5,1.8,3.7c1.3,0.2,2.6-1.1,2.9-2.9 c0.1-0.8,0-1.7-0.3-2.5c-0.1-0.3-0.3-0.5-0.5-0.7C74.2,70.4,73.9,70.2,73.6,70.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st11",
			d: "M68,72.7l-0.3-0.4c0.7-0.4,2.1-0.8,2.9,0.3l-0.4,0.3C69.5,71.8,68.1,72.6,68,72.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st11",
			d: "M50.8,71l-0.4-0.3c0.1-0.2,1.4-1.9,2.6-1.9c1.2,0,7.9,1.7,8.1,1.8L61,71c-1.9-0.5-7.2-1.8-8-1.7 C52.1,69.4,51.1,70.5,50.8,71z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st12",
			d: "M56.6,70.8c0,0-1.7-4.5-3.7-4c-2,0.5-1.4,6.6,0.4,7.9c0.2,0.2,0.5,0.3,0.8,0.4c0.3,0.1,0.6,0.1,0.9,0.1 c0.3,0,0.6-0.1,0.8-0.3c0.3-0.1,0.5-0.3,0.6-0.6L56.6,70.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "malle-working-st3",
			d: "M53.2,68.5C53.1,68.5,53.1,68.5,53.2,68.5c1.3,1,1.7,2.5,1.9,4c0-0.2-0.1-0.3-0.2-0.4 c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.3,0-0.5,0.1c0,0,0,0.1,0,0.1c0.3,0,0.5,0.1,0.8,0.2 c0.2,0.1,0.4,0.4,0.5,0.6c0.2,0.4,0.3,0.9,0.4,1.3c0,0.1,0.3,0.1,0.3,0v0C55.8,72.1,55.1,69.2,53.2,68.5z"
		})
	] }) })]
});
export default SvgMaleWorking;
